import { componentProvider } from 'js-component-framework';
import SiteHeader from './site-header';

import './site-header.scss';
import './site-header-minimal.scss';

const siteHeaderConfig = {
  name: 'site-header',
  component: SiteHeader,
};

componentProvider(siteHeaderConfig);
